import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export default function AuthCallback() {
  const [searchParams] = useSearchParams();
  const { login } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    const err = searchParams.get('error');

    if (err) {
      setError(decodeURIComponent(err));
      return;
    }

    if (token) {
      login(token);
      setTimeout(() => navigate('/'), 500);
    } else {
      setError('No token received. Please try again.');
    }
  }, [searchParams, login, navigate]);

  if (error) {
    return (
      <div className="min-h-screen bg-[var(--bg-base)] flex items-center justify-center">
        <div className="bg-[var(--bg-surface)] border border-red-500/30 rounded-xl p-8 max-w-md text-center">
          <div className="text-red-400 text-4xl mb-4">Auth Failed</div>
          <p className="text-zinc-400 mb-6">{error}</p>
          <button
            onClick={() => navigate('/login')}
            className="bg-[#5865F2] hover:bg-[#4752C4] text-white px-6 py-2 rounded-lg font-medium transition-colors"
          >
            Back to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[var(--bg-base)] flex items-center justify-center">
      <div className="flex flex-col items-center gap-4" data-testid="auth-callback-loading">
        <div className="w-12 h-12 border-2 border-[#5865F2] border-t-transparent rounded-full animate-spin" />
        <p className="text-zinc-400 font-[Manrope]">Authenticating with Discord...</p>
      </div>
    </div>
  );
}
